module.exports = __webpack_public_path__ + "static/logotypes-cc4dcbcd7d084a4c3d47d05513a4227c.svg";